import * as Yup from 'yup';

import { ContractTypes } from '@pharmaplan/common';
import strings from '../../../localization';

const Validator = () =>
  Yup.object().shape({
    selectedDate: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
    startTime: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
    endTime: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
  });

export default Validator;
